import { SvgIcon } from '@material-ui/core';

export const IconEvents = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0Zm4-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM0 3h24v7.038c-1.229-.491-3 .313-3 1.962s1.771 2.453 3 1.962V21H0v-7.036c1.225.503 2.99-.24 3-1.949a1.3 1.3 0 0 0 0-.03c-.01-1.71-1.775-2.452-3-1.95V3Zm2 12.814V19h20v-3.186a4.704 4.704 0 0 1-.619-.255C20.275 15.006 19 13.785 19 12c0-1.785 1.275-3.005 2.381-3.559.19-.094.397-.181.619-.255V5H2v3.186c.222.074.43.16.619.255C3.725 8.995 5 10.215 5 12c0 1.785-1.275 3.005-2.381 3.559-.19.094-.397.181-.619.255Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
